import React from 'react';
import PropTypes from 'prop-types';

import format from '../../../../utils/format';
import { ViewerPrimaryColorUserStyle } from '../../../UserCustomization';
import YesNoUnknown from '../../YesNoUnknown';

export function BuildingAdditionalDetails({ details }) {
  const { external, internal } = details;

  return (
    <section>
      <ViewerPrimaryColorUserStyle domStyle="color">
        <h4 className="section-title">Additional Details</h4>
      </ViewerPrimaryColorUserStyle>
      <div className="section-body">
        <ul>
          {external.constructionType && <li><strong>Construction Type: </strong>
            {external.constructionType}</li>}
          {external.buildingDimensions && <li><strong>Building Dimensions: </strong>
            {external.buildingDimensions}</li>}
          {(format(internal.officeSquareFeet) > '0') && <li><strong>Office SF: </strong>
            {format(internal.officeSquareFeet)}</li>}
          {internal.floorType && <li><strong>Floor Type: </strong>
            {internal.floorType}</li>}
          {(internal.floorThickness > 0) && <li><strong>Floor Thickness: </strong>
            {internal.floorThickness}&quot;</li>}
          {external.numberOfParkingSpaces > 0 && <li><strong>Parking Spaces: </strong>
            {external.numberOfParkingSpaces}</li>}
          {internal.firstInsuranceClassRating &&
          <li><strong>Fire Insurance Class Rating: </strong>
            {internal.firstInsuranceClassRating}</li>}
          {internal.covenantsLinkURL && <li><strong>Covenants: </strong>
            <a href={internal.covenantsLinkURL}>Link</a></li>}
          {internal.ceilingHeight > 0 && <li><strong>Ceiling Height: </strong>
            {internal.ceilingHeight}&apos;</li>}
          {internal.ceilingEaves > 0 && <li><strong>Ceiling Eaves: </strong>
            {internal.ceilingEaves}&apos;</li>}
          {internal.columnSpacing && <li><strong>Column Spacing: </strong>
            {internal.columnSpacing}</li>}
          {internal.sprinklerType && <li><strong>Sprinkler Type: </strong>
            {internal.sprinklerType}</li>}
          {internal.crane !== undefined && internal.crane !== null &&
          <li><strong>Crane: </strong> <YesNoUnknown value={internal.crane} /></li>}
          {internal.numberOfDockDoors > 0 && <li><strong>Dock Doors: </strong>
            {internal.numberOfDockDoors}</li>}
          {internal.numberOfDriveInDocks > 0 && <li><strong>Drive-In Doors: </strong>
            {internal.numberOfDriveInDocks}</li>}
          {internal.numberOfRailDoors > 0 && <li><strong>Rail Doors: </strong>
            {internal.numberOfRailDoors}</li>}
          {internal.dockAndDoorNotes > 0 && <li><strong>Dock & Door Notes: </strong>
            {internal.dockAndDoorNotes}</li>}
        </ul>
      </div>
    </section>
  );
}

BuildingAdditionalDetails.propTypes = {
  details: PropTypes.object.isRequired,
};

export default BuildingAdditionalDetails;



// WEBPACK FOOTER //
// ./src/components/PropertyDetail/PropertyDetailAdditional/AdditionalDetails/BuildingAdditionalDetails.js